"use client";

import { usePathname } from "next/navigation";
import { useNavigation } from "@/lib/navigation";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import React from "react";
import { useT } from "@/i18n/useT";
import { LOCALS } from "@/consts/settings";

export function LanguageSwitcher({
  compact = false,
}: { compact?: boolean } = {}) {
  const navigation = useNavigation();
  const pathname = usePathname();
  const t = useT("ui.theme");
  // Supported locales

  // Detect current locale from pathname
  const currentLocale =
    LOCALS.find((l) => pathname.startsWith(`/${l.code}`))?.code || "en";

  const handleChange = (e: SelectChangeEvent) => {
    const newLocale = e.target.value;

    navigation.switchLanguage(
      newLocale,
      pathname,
      LOCALS.map((l) => l.code),
      { locale: newLocale, reason: "User language selection" }
    );
  };

  return (
    <Box
      sx={{
        fontSize: 16,
        width: 80,
        minWidth: 80,
        ".MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
        },
      }}
    >
      <FormControl size={compact ? "small" : "medium"}>
        <InputLabel id="select-language-input-label">
          {t("language")}
        </InputLabel>
        <Select
          labelId="select-language-input-label"
          id="select-language"
          value={currentLocale}
          onChange={handleChange}
          aria-label="Select language"
          label={t("language")}
          MenuProps={{
            sx: {
              zIndex: 1302, // Ensure dropdown appears above header
            },
          }}
        >
          {LOCALS.map((locale) => (
            <MenuItem
              key={locale.code}
              value={locale.code}
              sx={{ justifyContent: "center" }}
            >
              {compact ? locale.code.toUpperCase() : locale.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
